export default __webpack_public_path__ + "static/Atinyislewithanunspokenlanguage-5c78695c31c7b9cd057cdb94d10e135b.jpg";